<template>
  <Layout>
    <div class="bloco">
      <HeaderPage
        :form-open="formOpen"
        :page-titles="pageTitles"
        :hide-button="formEditOpen ? true : false"
        @onClick="abrirForm"
      />
      <div v-if="formOpen">
        <empresaParceiraForm
          ref="estoqueForm"
          :salvar="salvar"
          :set-loading="setLoading"
        />
      </div>
      <div v-else-if="formEditOpen">
        <empresaParceiraUpdateForm
          ref="estoqueForm"
          :salvar="editar"
          :set-loading="setLoading"
          :empresa-prop="empresa"
          :cancelar="cancelar"
        />
      </div>
      <div v-else>
        <Table
          :key="keyTable"
          :carregando="carregando"
          class="table-responsive table-striped col-12"
          :search="true"
          :form-open="formOpen"
          :tables-fields="grupoFields"
          :table-items="items"
          :page="0"
          :no-action="true"
        >
          <template v-slot:cell(actions)="row">
            <div>
              <b-button
                variant="primary"
                size="sm"
                class="m-1"
                @click="visualizarFiliais(row.item)"
              >
                <b-icon-building />
              </b-button>
              <b-button
                variant="primary"
                size="sm"
                class="m-1"
                @click="visualizarColaboradores(row.item)"
              >
                <b-icon-people />
              </b-button>
              <b-button
                variant="warning"
                size="sm"
                class="m-1"
                @click="edit(row.item)"
              >
                <b-icon-pen />
              </b-button>
              <b-button
                variant="danger"
                size="sm"
                class="m-1"
                @click="modalDelete(row.item._id)"
              >
                <b-icon-trash />
              </b-button>
            </div>
          </template>
        </Table>
      </div>
    </div>
    <b-modal
      id="modal-1"
      v-model="modalOpen"
      size="lg"
      title="Filiais"
      :hide-footer="true"
    >
      <ul>
        <li v-for="item in empresaDetails" :key="item.id">{{ item.nome }}</li>
      </ul>
    </b-modal>
    <b-modal v-model="modalDeleteOpen" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="modal = false">Não</b-button>
        <b-button variant="danger" @click="deleteEmpresa">Sim</b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-2"
      v-model="modalEmployeeOpen"
      size="lg"
      title="Colaboradores"
      :hide-footer="true"
    >
      <Table
        :key="keyTable"
        :carregando="carregando"
        :search="true"
        :form-open="formOpen"
        :tables-fields="fieldsEmployees"
        :table-items="dataEmployees"
        :page="0"
        :no-action="true"
        :cadastrar="cadastrar"
      >
        <template v-slot:cell(ativo)="row">
          <b-badge :variant="row.item.ativo ? 'success' : 'danger'" class="m-1">
            {{ row.item.ativo ? 'Ativo' : 'Inativo' }}
          </b-badge>
        </template>
        <template v-slot:cell(actions)="row">
          <div v-if="row.item.ativo === true">
            <b-button
              variant="danger"
              size="sm"
              class="m-1"
              title="Desativar"
              @click="disable(row.item)"
            >
              <b-icon-x-circle />
            </b-button>
          </div>
          <div v-else>
            <b-button
              variant="success"
              size="sm"
              class="m-1"
              title="Ativar"
              @click="disable(row.item)"
            >
              <b-icon-box-arrow-up />
            </b-button>
          </div>
        </template>
      </Table>
    </b-modal>
    <b-modal
      id="modal-3"
      v-model="openCadastrarColaborador"
      size="lg"
      title="Cadastrar Colaborador"
      ok-title="Cadastrar"
      cancel-title="Cancelar"
      @ok="cadastrarColaborador"
    >
      <b-row>
        <b-col cols="12" md="12">
          <b-form-group
            label="Nome"
            label-for="nome"
            :invalid-feedback="errors.nome"
            :state="errors.nome ? false : null"
          >
            <b-form-input
              id="nome"
              v-model="colaborador.nome"
              :state="errors.nome ? false : null"
              placeholder="Nome"
              @keyup.enter="cadastrarColaborador"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-group
            label="CPF"
            label-for="cpf"
            :invalid-feedback="errors.cpf"
            :state="errors.cpf ? false : null"
          >
            <b-form-input
              id="cpf"
              v-model="colaborador.cpf"
              v-mask="'###.###.###-##'"
              :state="errors.cpf ? false : null"
              placeholder="CPF"
              @keyup.enter="cadastrarColaborador"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <loading-component :is-loading="isLoading" :text="messageFeedbackLoading" :message-error="errorMessage"/>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import empresaParceiraForm from '@/src/components/forms/controleObra/empresaParceiraForm.vue'
import empresaParceiraUpdateForm from '@/src/components/forms/controleObra/empresaParceiraUpdateForm.vue'
import Table from '@/src/components/tables/table-register.vue'
import alertMixin from '@/src/mixins/alertMixin'
import serviceEmpresasParceiras from '@/src/services/serviceEmpresasParceiras'
import LoadingComponent from '@/src/components/loading/loading-component.vue'

export default {
  components: {
    Layout,
    HeaderPage,
    empresaParceiraForm,
    empresaParceiraUpdateForm,
    Table,
    LoadingComponent,
  },
  mixins: [alertMixin],
  data() {
    return {
      messageFeedbackLoading: '',
      errorMessage: '',
      keyTable: 0,
      itemId: '',
      modalDeleteOpen: false,
      carregando: false,
      insumoSearch: '',
      isLoading: false,
      pageTitles: {
        title: 'Empresas Parceiras',
        subtitle: 'Gerencie as empresas parceiras por filial',
      },
      formOpen: false,
      formEditOpen: false,
      grupoFields: [
        {
          key: 'nome',
          label: 'Nome',
        },
        {
          key: 'cnpjCpf',
          label: 'CPF/CNPJ',
        },
        {
          key: 'email',
          label: 'E-mail',
          class: 'd-flex flex-wrap',
        },
        {
          key: 'telefone',
          label: 'Telefone',
        },
        {
          key: 'responsavel',
          label: 'Responsável',
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      empresa: {},
      empresaDetails: [],
      modalOpen: false,
      items: [],
      modalEmployeeOpen: false,
      dataEmployees: [],
      rowsEmployees: 0,
      openCadastrarColaborador: false,
      fieldsEmployees: [
        {
          label: 'Nome',
          key: 'nome',
          sortable: true,
          class: 'align-middle text-center',
        },
        {
          label: 'CPF',
          key: 'cpf',
          sortable: true,
          class: 'align-middle text-center',
        },
        {
          label: 'Status',
          key: 'ativo',
          sortable: true,
          class: 'align-middle text-center',
        },
        {
          key: 'actions',
          label: '',
          class: 'align-middle text-center',
        },
      ],
      colaborador: {
        nome: '',
        cpf: '',
        empresaParceira: '',
      },
      empresaCurrent: {},
    }
  },
  async mounted() {
    await Promise.all([this.listaEmpresas()])
  },
  methods: {
    async cadastrarColaborador() {
      this.isLoading = true

      if (!this.colaborador.nome) {
        this.errorMessage('Nome é obrigatório')

        this.isLoading = false
        return
      }

      if (!this.colaborador.cpf) {
        this.errorMessage('CPF é obrigatório')

        this.isLoading = false
        return
      }

      serviceEmpresasParceiras
        .createColaborador(this.colaborador)
        .then(() => {
          this.successMessage('Colaborador cadastrado com sucesso')
          setTimeout(() => {
            this.visualizarColaboradores(this.empresaCurrent)
          }, 1000)

          this.openCadastrarColaborador = false
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage(error.response.data.error.message)
          setTimeout(() => {
            this.visualizarColaboradores(this.empresaCurrent)
          }, 1000)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    cadastrar() {
      this.openCadastrarColaborador = true

      this.colaborador = {
        nome: '',
        cpf: '',
        empresaParceira: this.empresaCurrent._id,
      }
    },
    async visualizarColaboradores(empresa) {
      this.empresaCurrent = empresa
      this.messageFeedbackLoading = 'Carregando colaboradores...'
      this.isLoading = true
      let empresaId

      if (empresa._id) {
        empresaId = empresa._id
      } else {
        empresaId = empresa
      }

      serviceEmpresasParceiras
        .listColaboradoresEmpresa(empresaId)
        .then((res) => {
          const dataEmployees = res.data
          this.dataEmployees = dataEmployees

          this.rowsEmployees = res.data.length
          this.modalEmployeeOpen = true
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage(`Erro ao listar colaboradores`)
        })
        .finally(() => {
          this.isLoading = false
          this.messageFeedbackLoading = ''
        })
    },
    async disable(item) {
      this.isLoading = true

      serviceEmpresasParceiras
        .updateColaborador(item.cpf)
        .then(() => {
          if (item.ativo) {
            this.successMessage('Colaborador desativado com sucesso')
          } else {
            this.successMessage('Colaborador ativado com sucesso')
          }

          this.visualizarColaboradores(item.empresaParceira)
            .then(() => {
              this.isLoading = true
            })
            .catch(() => {
              this.errorMessage(`Erro ao listar colaboradores`)

              this.modalEmployeeOpen = false
            })
            .finally(() => {
              this.isLoading = false
            })
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage(`Erro ao desativar colaborador`)

          setTimeout(() => {
            this.visualizarColaboradores(item.empresaParceira)
          }, 1000)

          this.isLoading = false
        })
    },
    updateByFiliais() {
      this.listaEmpresas()
      if (this.formOpen) {
        this.$refs.estoqueForm.listaObra()
      }
    },
    setLoading(loading) {
      this.isLoading = loading
    },
    modalDelete(item) {
      this.modalDeleteOpen = true
      this.itemId = item
    },
    abrirForm() {
      this.formOpen = !this.formOpen
      this.estoque = {}
      this.isUpdating = false
      if (!this.formOpen) {
        this.listaEmpresas()
      }
    },
    listaEmpresas(message) {
      this.messageFeedbackLoading = message || 'Carregando empresas...'
      this.isLoading = true

      serviceEmpresasParceiras
        .consulting(this.$store.state.filial)
        .then((res) => {
          const data = res.data
          this.items = data

          this.rows = data.length
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage(`Erro ao listar empresas`)
        })
        .finally(() => {
          this.isLoading = false
          this.messageFeedbackLoading = ''
        })
    },
    formatValue() {
      let formattedValue = this.estoque.valor_unitario
      formattedValue = formattedValue.replace('R$', '')
      formattedValue = formattedValue.replace('.', '')
      formattedValue = formattedValue.replace(',', '.')
      formattedValue = formattedValue.trim()

      return formattedValue
    },
    async salvar(empresa) {
      this.messageFeedbackLoading = 'Salvando empresa...'
      this.carregando = true

      serviceEmpresasParceiras
        .create(empresa)
        .then(() => {
          this.successMessage('Empresa cadastrada com sucesso')
          this.listaEmpresas()
          this.abrirForm()
        })
        .catch((error) => {
          this.errorMessage(error.response.data.error.message)
        })
        .finally(() => {
          this.messageFeedbackLoading = ''
          this.carregando = false
        })
    },
    async edit(empresa) {
      this.empresa = empresa
      this.formEditOpen = true
    },
    async editar(empresa) {
      this.messageFeedbackLoading = 'Atualizando empresa...'
      this.isLoading = true

      serviceEmpresasParceiras
        .update(empresa._id, empresa)
        .then(() => {
          this.listaEmpresas('Empresa atualizada com sucesso, atualizando lista...')
          this.formEditOpen = false
        })
        .catch((error) => {
          this.errorMessage(error.response.data.error.message)
        })
    },
    cancelar() {
      this.formEditOpen = false
      this.listaEmpresas()
    },
    visualizarFiliais(empresa) {
      const filiais = this.$store.state.auth.currentUser.user.filiais

      this.empresaDetails = empresa.filiais.map((filial) =>
        filiais.find((f) => String(f._id) === String(filial))
      )

      this.modalOpen = true
    },
    async deleteEmpresa() {
      this.messageFeedbackLoading = 'Apagando empresa parceira...'
      try {
        this.isLoading = true
        await serviceEmpresasParceiras.remove(this.itemId)
        this.listaEmpresas('Empresa parceira apagada com sucesso, atualizando lista...')
        this.estoque = {}
      } catch (error) {
        this.isLoading = false
        this.errorMessage(error.response.data.error.message)
      } finally {
        this.modalDeleteOpen = false
      }
    },
  },
}
</script>
<style src="../style.scss" lang="scss"></style>
